import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=8fde96ba&scoped=true&"
import script from "./MainContent.vue?vue&type=script&lang=ts&"
export * from "./MainContent.vue?vue&type=script&lang=ts&"
import style0 from "./MainContent.vue?vue&type=style&index=0&id=8fde96ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fde96ba",
  null
  
)

export default component.exports